export default (function (_ref) {
  var request = _ref.request;
  return {
    diseasesSymptomAdd: function diseasesSymptomAdd(data) {
      return request({
        url: '/cms/diseasesSymptom/add',
        method: 'post',
        data: data
      });
    },
    diseasesSymptomModify: function diseasesSymptomModify(data) {
      return request({
        url: "/cms/diseasesSymptom/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    diseasesSymptomDel: function diseasesSymptomDel(id) {
      return request({
        url: "/cms/diseasesSymptom/".concat(id, "/del"),
        method: 'delete'
      });
    },
    diseasesSymptomQueryForBreedDiseasesJoinCategory: function diseasesSymptomQueryForBreedDiseasesJoinCategory(data) {
      return request({
        url: '/cms/diseasesSymptom/queryForBreedDiseasesJoinCategory',
        method: 'get',
        params: data
      });
    },
    diseasesSymptomQueryJoinCategory: function diseasesSymptomQueryJoinCategory(data) {
      return request({
        url: '/cms/diseasesSymptom/queryJoinCategory',
        method: 'get',
        params: data
      });
    },
    diseasesSymptomDetail: function diseasesSymptomDetail(id) {
      return request({
        url: "/cms/diseasesSymptom/".concat(id),
        method: 'get'
      });
    }
  };
});